import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../utils/Requests/axios";
import LanguageContext from "../../utils/Contexts/LanguageContext";

function ResetPassword() {
  const navigate = useNavigate();
  const { t } = useContext(LanguageContext);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const { token } = useParams();
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const validate = () => {
    const newErrors = {};

    if (!password) {
      newErrors.password = "Password is required.";
    } else if (password.length < 8) {
      newErrors.password = "Password must be at least 8 characters long.";
    }

    // Check if confirmPassword is empty
    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm password is required.";
    } else if (confirmPassword !== password) {
      newErrors.confirmPassword = "Passwords do not match.";
    }
    return newErrors;
  };

  useEffect(() => {
    // Clear errors when the user starts typing
    const validationErrors = validate();
    setErrors(validationErrors);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [password, confirmPassword]);

  const handleReset = (e) => {
    e.preventDefault();
    setSubmitted(true);
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    axiosInstance
      .post(`/auth/reset-password/${token}`, {
        password: password,
        cpassword: confirmPassword,
      })
      .then(() => {
        navigate("/sign-in");
        // Handle success logic (e.g., redirect, show a message)
        // onVerifyEmail()
      })
      .catch((error) => {
        console.error("Error occured in sending reset password request:", error);
        // Handle error logic (e.g., show error message)
      });
  };

  return (
    <div
      className="w-100 content-space-t-4 content-space-t-lg-2 content-space-b-1"
      style={{ maxWidth: "25rem" }}
      onSubmit={handleReset}
    >
      <form className="js-validate needs-validation" novalidate="">
        <div className="text-center">
          <div className="mb-5">
            <h1 className="display-5">{t("Reset your password")}</h1>
          </div>
        </div>
        <div className="mb-4">
          <label
            className="form-label w-100"
            htmlFor="signupSrPassword"
            tabIndex="0"
          >
            <span className="d-flex justify-content-between align-items-center">
              <span>{t("Password")}</span>
            </span>
          </label>
          <div
            className={`input-group input-group-merge ${
              submitted && errors.password
                ? "is-invalid"
                : submitted && password
                ? "is-valid"
                : ""
            }`}
            data-hs-validation-validate-classname=""
          >
            <input
              type={showPassword ? "text" : "password"}
              className="js-toggle-password form-control form-control-lg"
              name="password"
              id="signupSrPassword"
              placeholder="8+ characters required"
              aria-label="8+ characters required"
              required=""
              minLength="8"
              data-hs-toggle-password-options='{
                "target": [".js-toggle-password-target-1", ".js-toggle-password-target-2"],
                "defaultClass": "bi-eye-slash",
                "showClass": "bi-eye",
                "classChangeTarget": ".js-toggle-password-show-icon-1"
              }'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <div
              className="js-toggle-password-target-1 input-group-append input-group-text"
              onClick={() => setShowPassword(!showPassword)} // Toggle password visibility
              style={{ cursor: "pointer" }}
            >
              <i
                className={`js-toggle-password-show-icon-1 bi ${
                  showPassword ? "bi-eye" : "bi-eye-slash"
                }`}
              ></i>
            </div>
          </div>

          {submitted && errors.password && (
            <span className="invalid-feedback">
              {t(errors.password)}
            </span>
          )}
        </div>
        <div className="mb-4">
          <label
            className="form-label w-100"
            htmlFor="signupSrPassword"
            tabIndex="0"
          >
            <span className="d-flex justify-content-between align-items-center">
              <span>{t("Confirm password")}</span>
            </span>
          </label>
          <div
            className={`input-group input-group-merge ${
              submitted && errors.confirmPassword
                ? "is-invalid"
                : submitted && confirmPassword
                ? "is-valid"
                : ""
            }`}
            data-hs-validation-validate-classname=""
          >
            <input
              type={showConfirmPassword ? "text" : "password"}
              className="js-toggle-password form-control form-control-lg"
              name="password"
              id="signupSrPassword"
              placeholder="8+ characters required"
              aria-label="8+ characters required"
              required=""
              minLength="8"
              data-hs-toggle-password-options='{
                "target": [".js-toggle-password-target-1", ".js-toggle-password-target-2"],
                "defaultClass": "bi-eye-slash",
                "showClass": "bi-eye",
                "classChangeTarget": ".js-toggle-password-show-icon-1"
              }'
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <div
              className="js-toggle-password-target-1 input-group-append input-group-text"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)} // Toggle password visibility
              style={{ cursor: "pointer" }}
            >
              <i
                className={`js-toggle-password-show-icon-1 bi ${
                  showConfirmPassword ? "bi-eye" : "bi-eye-slash"
                }`}
              ></i>
            </div>
          </div>

          {submitted && errors.confirmPassword && (
            <span className="invalid-feedback">
              {t(errors.confirmPassword)}
            </span>
          )}
        </div>
        <div className="d-grid gap-2">
          <button type="submit" className="btn btn-primary btn-lg">
            {t("Reset")}
          </button>
        </div>
      </form>
    </div>
  );
}

export default ResetPassword;
